import dynamic from 'next/dynamic'

import { Loading } from 'common/widgets'


const FlipBoxes = dynamic(() => import('./FlipBoxes'), { loading: () => <Loading isLoading fontSize={36} /> })

export default FlipBoxes
